<script lang="ts">
    import { Route, Router } from 'yrv'
    import Ztab from '../_common/z/ztab.svelte'
    import Content from '../_common/content.svelte'
    import CustomerBalanceEntries from './customer-balance-entries.svelte'

    let tabs = [
        {
            title: 'Controle de Saldos',
            url: '/customer-balance/entries',
        },
    ]
    // if (!window.store.token.permissions.customerService.configs.write) {
    //     tabs.splice(1, 1)
    // }
</script>

<div class="root-content">
    <Ztab class="h-space" {tabs} />
    <Content>
        <Router>
            <Route path="/entries">
                <CustomerBalanceEntries></CustomerBalanceEntries>
            </Route>
        </Router>
    </Content>
</div>
